import { combineReducers } from 'redux';
import * as types from './types';

const snackBarDefaults = {
    anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
    },
    open: false,
    message: 'this is a warning',
    severity: 'warning',
};

const snackbar = (state = snackBarDefaults, action) => {
    const { payload } = action;
    switch (action.type) {
        case types.SHOW_SNACKBAR:
            return {
                ...state,
                open: true,
                ...payload,
            };
        case types.HIDE_SNACKBAR:
            return {
                ...state,
                open: false,
            };
        default:
            return state;
    }
};

const modalDefaults = {
    isOpen: false,
};

const modal = (state = modalDefaults, action) => {
    const { payload } = action;
    switch (action.type) {
        case types.SHOW_MODAL:
            return {
                ...state,
                ...payload,
            };
        case types.HIDE_MODAL:
            return {
                ...state,
                open: false,
            };
        default:
            return state;
    }
};

const dialogDefaults = {
    open: false,
};

const dialog = (state = dialogDefaults, action) => {
    const { payload } = action;
    switch (action.type) {
        case types.SHOW_DIALOG:
            return {
                ...state,
                ...payload,
            };
        case types.HIDE_DIALOG:
            return {
                open: false,
            };
        default:
            return state;
    }
};

const alerts = combineReducers({
    snackbar,
    modal,
    dialog,
});

export default alerts;
